import { type ClassValue, clsx } from "clsx"
import type { InsurancePlan } from "src/services/interfaces/insurance";
import type { Member } from "src/services/members.service";
import { twMerge } from "tailwind-merge"

export interface PlanWithPrice extends InsurancePlan {
  price: number
}

export interface MemberWithPlans extends Member {
  plans: PlanWithPrice[];
  sumPrice: number;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const transformMembers = (members: Member[], allPlans: InsurancePlan[]): MemberWithPlans[] => {
  return members.map((member) => {
    let sumPrice = 0;
    const plans = member.subscriptions.flatMap((subscription) => {
      return subscription.plans.map((plan) => {
        const planData = allPlans.find((p) => p.id === plan.planId);
        const priceData = planData?.prices.find((p) => p.id === plan.priceId);
        const priceValue = priceData?.price || 0;
        sumPrice += priceValue;
        return {
            ...planData,
            price: priceValue,
        } as PlanWithPrice;
      });
    });
    return {
      ...member,
      plans,
      sumPrice,
    };
  });
};